import { Component, OnInit, ViewChild } from '@angular/core';
import { CrudService } from '~services/crud.service';
import { filter, take } from 'rxjs/operators';
import { BonusApiService } from '~services/api/bonus.api.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { RouterStateService } from '~services/router-state.service';
import * as fromRouterConstants from '../../app-routing.constants';
import { loading } from '~admin/services/dataHelper';
import { BonusEventDetailComponent } from '../bonus-event-detail/bonus-event-detail.component';
import { ConfirmActionDialogComponent } from '../../ui-components/confirm-action-dialog/confirm-action-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'sa-create-bonus-event',
  templateUrl: './create-bonus-event.component.html',
  styleUrls: ['./create-bonus-event.component.scss'],
})
export class CreateBonusEventComponent implements OnInit {
  constructor(
    private crud: CrudService,
    private snackBar: MatSnackBar,
    private bonusApiService: BonusApiService,
    public router: Router,
    private route: ActivatedRoute,
    private routerState: RouterStateService,
    private matDialog: MatDialog,
  ) {}
  @ViewChild(BonusEventDetailComponent, { static: false })
  private bonusEventDetailComponent: BonusEventDetailComponent;
  public isLoading = true;
  public isDisableForm = false;
  selectedBonusEvent: any;
  protected readonly loading = loading;
  type = 'new';
  backTab = 'active';
  isSaving = false;

  ngOnInit(): void {
    this.type = this.route.snapshot.params['type'];
    if (this.type === 'view') {
      this.isDisableForm = true;
    }

    this.crud.httpClientReady.pipe(filter(Boolean), take(1)).subscribe(() => {
      this.routerState.listenForParamChange$(fromRouterConstants.GOHAWK_BONUS_EVENT_ID).subscribe((bonusEventID) => {
        if (bonusEventID) {
          this.bonusApiService.getBonusEvent(bonusEventID).subscribe((item) => {
            this.selectedBonusEvent = item;
            this.isLoading = false;
            if (!this.isDisableForm) {
              this.isDisableForm = this.selectedBonusEvent.archivedAt !== null;
            }
            if (this.selectedBonusEvent.archivedAt) {
              this.backTab = 'completed';
            }
          });
        } else {
          this.isLoading = false;
        }
      });
    });
  }

  public onSave() {
    this.isSaving = true;
    const body = this.bonusEventDetailComponent.onSubmit();
    if (body) {
      if (this.selectedBonusEvent) {
        this.bonusApiService.updateBonusEvent(this.selectedBonusEvent.id, body).subscribe(
          (item) => {
            this.snackBar.open('Bonus event successfully updated', null, {
              duration: 2000,
            });
            this.router.navigateByUrl('/bonus-event/active');
            this.isSaving = false;
          },
          (error) => {
            this.snackBar.open(error.error ? error.error.Message : error.Message, null, {
              duration: 5000,
              panelClass: ['snackbar-error'],
            });
            this.isSaving = false;
          },
        );
      } else {
        this.bonusApiService.createBonusEvent(body).subscribe(
          (item) => {
            this.snackBar.open('Bonus event successfully created', null, {
              duration: 2000,
            });
            this.router.navigateByUrl('/bonus-event/active');
            this.isSaving = false;
          },
          (error) => {
            this.snackBar.open(error.error ? error.error.Message : error.Message, null, {
              duration: 5000,
              panelClass: ['snackbar-error'],
            });
            this.isSaving = false;
          },
        );
      }
    } else {
      this.isSaving = false;
    }
  }

  async endBonusEvent() {
    this.isSaving = true;
    let keepGoing = true;
    const confirmDialogRef = this.matDialog.open(ConfirmActionDialogComponent, {
      data: {
        cancelButtonText: 'Cancel',
        desc: 'Are you sure you want to end this bonus event permanently?',
        submitButtonText: 'Confirm',
        title: `End ${this.selectedBonusEvent.name}`,
      },
    });

    keepGoing = await confirmDialogRef.afterClosed().toPromise();
    if (!keepGoing) {
      return;
    }

    this.bonusApiService.deleteBonusEvent(this.selectedBonusEvent.id).subscribe(
      () => {
        this.snackBar.open('Bonus event successfully ended', null, {
          duration: 2000,
        });
        this.router.navigateByUrl('/bonus-event/completed');
        this.isSaving = false;
      },
      (error) => {
        this.snackBar.open(error.error ? error.error.Message : error.Message, null, {
          duration: 5000,
          panelClass: ['snackbar-error'],
        });
        this.isSaving = false;
      },
    );
  }
}
